import { Navigate, Route, Routes } from 'react-router'
import { PrivateLayout } from '@/components/layouts'
import { ROUTES } from '@/constants/routes'
import { ActionsInProgressPage } from '@/pages/actions-in-progress-page'
import { AdministrationGroupPage } from '@/pages/administration-group-page'
import { AdministrationPage } from '@/pages/administrations-home-page'
import { CampaignFormPage } from '@/pages/campaign-form-page'
import { CampaignRespondPage } from '@/pages/campaign-respond-page'
import { CampaignResultsPage } from '@/pages/campaign-results-page'
import { CampaignsAdminPage } from '@/pages/campaigns-admin-page'
import { CampaignsPage } from '@/pages/campaigns-page'
import { ClassificationsPage } from '@/pages/classifications-page'
import { CommitmentMatrixDashboardPage } from '@/pages/commitment-matrix-dashboard-page'
import { CommitmentMatrixPage } from '@/pages/commitment-matrix-page'
import { ContractsPage } from '@/pages/contracts-page'
import { CorrectInspectionPage } from '@/pages/correct-inspection-page'
import { CustomerClassificationsPage } from '@/pages/customer-classifications-page'
import { CustomersPage } from '@/pages/customers-page'
import { DDSAttendancePage } from '@/pages/dds-attendance-page'
import { DDSCheckInPage } from '@/pages/dds-check-in-page'
import { DDSEmotionsPage } from '@/pages/dds-emotions-page'
import { DDSHubPage } from '@/pages/dds-hub-page'
import { DDSListPage } from '@/pages/dds-list-page'
import { DDSMonthlyThemesPage } from '@/pages/dds-monthly-themes-page'
import { DDSPage } from '@/pages/dds-page'
import { DirectedInspectionListPage } from '@/pages/directed-inspection-list-page'
import { DirectedInspectionPage } from '@/pages/directed-inspection-page'
import { ForceChangePasswordPage } from '@/pages/force-change-password-page'
import { HomePage } from '@/pages/home-page'
import { InspectionsPage } from '@/pages/inspections-home-page'
import { InteractionListPage } from '@/pages/interaction-list-page'
import { InteractionPage } from '@/pages/interaction-page'
import { KpiMetricsPage } from '@/pages/kpi-metrics-page'
import { LoginPage } from '@/pages/login-page'
import { MyCommitmentExceptionsPage } from '@/pages/my-commitment-exceptions-page'
import { NoticeDetailPage } from '@/pages/notice-detail-page'
import { NoticesPage } from '@/pages/notices-page'
import { NotificationFormPage } from '@/pages/notification-form-page'
import { NotificationsPage } from '@/pages/notifications-page'
import { OccurrenceLayout } from '@/pages/occurrences/occurrence-layout'
import { OccurrenceNewPage } from '@/pages/occurrences/occurrence-new-page'
import { OccurrencesListPage } from '@/pages/occurrences/occurrences-list-page'
import { ActionsSection } from '@/pages/occurrences/section-actions'
import { InvestigationSection } from '@/pages/occurrences/section-investigation'
import { MatrixSection } from '@/pages/occurrences/section-matrix'
import {
	CommitteeSection,
	EvidenceSection,
	TestimoniesSection,
	TimelineSection,
} from '@/pages/occurrences/sections-apuration'
import {
	AuditSection,
	ClosureSection,
	DocumentsSection,
	LessonSection,
	MedicalSection,
} from '@/pages/occurrences/sections-governance'
import {
	ClassificationSection,
	DataSection,
	EmployeeSection,
	SummarySection,
} from '@/pages/occurrences/sections-register'
import { OrgOverridesPage } from '@/pages/org-overrides-page'
import { ProfilePage } from '@/pages/profile-page'
import { QuestionnairesPage } from '@/pages/questionnaires-page'
import { RecoverPasswordPage } from '@/pages/recover-password-page'
import { ScoringPage } from '@/pages/scoring-page'
import { SeeAndActListPage } from '@/pages/see-and-act-list-page'
import { SeeAndActPage } from '@/pages/see-and-act-page'
import { SpheraExportPage } from '@/pages/sphera-export-page'
import { SpheraOptionsPage } from '@/pages/sphera-options-page'
import { SyncProtheusPage } from '@/pages/sync-protheus-page'
import { TypologyRisksPage } from '@/pages/typology-risks-page'
import { UsersPage } from '@/pages/users-page'
import { VirtualBadgePage } from '@/pages/virtual-badge-page'
import { WhatsNewPage } from '@/pages/whats-new-page'
import { YellowCardListPage } from '@/pages/yellow-card-list-page'
import { YellowCardPage } from '@/pages/yellow-card-page'
import { DDSDetailPage } from '../pages/dds-detail-page'

export const AppRoutes = () => {
	return (
		<Routes>
			{/* ========== PUBLIC ROUTES ========== */}
			<Route element={<LoginPage />} path={ROUTES.PUBLIC.LOGIN} />
			<Route
				element={<ForceChangePasswordPage />}
				path={ROUTES.PUBLIC.FORCE_CHANGE_PASSWORD}
			/>
			<Route
				element={<RecoverPasswordPage />}
				path={ROUTES.PUBLIC.RECOVER_PASSWORD}
			/>

			{/* ========== PRIVATE ROUTES ========== */}
			<Route element={<PrivateLayout />}>
				<Route element={<HomePage />} path={ROUTES.DASHBOARD.HOME} />
				<Route element={<ProfilePage />} path={ROUTES.DASHBOARD.PROFILE} />
				<Route
					element={<VirtualBadgePage />}
					path={ROUTES.DASHBOARD.VIRTUAL_BADGE}
				/>
				<Route element={<NoticesPage />} path={ROUTES.DASHBOARD.NOTICES} />
				<Route
					element={<NoticeDetailPage />}
					path={ROUTES.DASHBOARD.NOTICE_DETAIL}
				/>
				<Route element={<CampaignsPage />} path={ROUTES.DASHBOARD.CAMPAIGNS} />
				<Route
					element={<CampaignRespondPage />}
					path={ROUTES.DASHBOARD.CAMPAIGN_DETAIL}
				/>
				<Route
					element={<MyCommitmentExceptionsPage />}
					path={ROUTES.DASHBOARD.MY_COMMITMENT_EXCEPTIONS}
				/>
				<Route
					element={<CommitmentMatrixDashboardPage />}
					path={ROUTES.DASHBOARD.COMMITMENT_MATRIX_DASHBOARD}
				/>

				{/* ========== INSPECTIONS MODULE ========== */}
				<Route element={<InspectionsPage />} path={ROUTES.INSPECTIONS.INDEX} />
				<Route
					element={<DirectedInspectionListPage />}
					path={ROUTES.INSPECTIONS.DIRECTED.INDEX}
				/>
				<Route
					element={<DirectedInspectionPage />}
					path={ROUTES.INSPECTIONS.DIRECTED.NEW}
				/>
				<Route
					element={<SeeAndActListPage />}
					path={ROUTES.INSPECTIONS.SEE_AND_ACT.INDEX}
				/>
				<Route
					element={<SeeAndActPage />}
					path={ROUTES.INSPECTIONS.SEE_AND_ACT.NEW}
				/>
				<Route
					element={<YellowCardListPage />}
					path={ROUTES.INSPECTIONS.YELLOW_CARD.INDEX}
				/>
				<Route
					element={<YellowCardPage />}
					path={ROUTES.INSPECTIONS.YELLOW_CARD.NEW}
				/>
				<Route
					element={<InteractionListPage />}
					path={ROUTES.INSPECTIONS.INTERACTION.INDEX}
				/>
				<Route
					element={<InteractionPage />}
					path={ROUTES.INSPECTIONS.INTERACTION.NEW}
				/>
				<Route
					element={<ActionsInProgressPage />}
					path={ROUTES.INSPECTIONS.ACTIONS_IN_PROGRESS}
				/>

				{/* ========== OCCURRENCES MODULE (prototype, mock data) ========== */}
				<Route
					element={<OccurrencesListPage />}
					path={ROUTES.OCCURRENCES.INDEX}
				/>
				<Route element={<OccurrenceNewPage />} path={ROUTES.OCCURRENCES.NEW} />
				<Route element={<OccurrenceLayout />} path={ROUTES.OCCURRENCES.DETAIL}>
					<Route index element={<SummarySection />} />
					<Route element={<DataSection />} path="data" />
					<Route element={<EmployeeSection />} path="employee" />
					<Route element={<ClassificationSection />} path="classification" />
					<Route element={<EvidenceSection />} path="evidence" />
					<Route element={<TestimoniesSection />} path="testimonies" />
					<Route element={<CommitteeSection />} path="committee" />
					<Route element={<TimelineSection />} path="timeline" />
					<Route element={<InvestigationSection />} path="investigation" />
					<Route element={<MatrixSection />} path="matrix" />
					<Route element={<ActionsSection />} path="actions" />
					<Route element={<LessonSection />} path="lesson" />
					<Route element={<MedicalSection />} path="medical" />
					<Route element={<DocumentsSection />} path="documents" />
					<Route element={<ClosureSection />} path="closure" />
					<Route element={<AuditSection />} path="audit" />
				</Route>

				{/* ========== DDS MODULE ========== */}
				<Route element={<DDSListPage />} path={ROUTES.DDS.INDEX} />
				<Route element={<DDSPage />} path={ROUTES.DDS.NEW} />
				<Route element={<DDSDetailPage />} path={ROUTES.DDS.DETAIL} />
				<Route element={<DDSHubPage />} path={ROUTES.DDS.HUB} />
				<Route element={<DDSCheckInPage />} path={ROUTES.DDS.CHECK_IN} />
				<Route element={<DDSAttendancePage />} path={ROUTES.DDS.ATTENDANCE} />
				<Route element={<DDSEmotionsPage />} path={ROUTES.DDS.EMOTIONS} />

				{/* ========== ADMINISTRATION MODULE ========== */}
				<Route
					element={<AdministrationPage />}
					path={ROUTES.ADMINISTRATION.INDEX}
				/>
				<Route
					element={<AdministrationGroupPage />}
					path={ROUTES.ADMINISTRATION.GROUP}
				/>
				<Route
					element={<WhatsNewPage />}
					path={ROUTES.ADMINISTRATION.WHATS_NEW}
				/>
				<Route
					element={<QuestionnairesPage />}
					path={ROUTES.ADMINISTRATION.QUESTIONNAIRES}
				/>
				<Route
					element={<NotificationsPage />}
					path={ROUTES.ADMINISTRATION.NOTIFICATIONS}
				/>
				<Route
					element={<NotificationFormPage />}
					path={ROUTES.ADMINISTRATION.NOTIFICATIONS_FORM}
				/>
				<Route
					element={<CampaignsAdminPage />}
					path={ROUTES.ADMINISTRATION.CAMPAIGNS}
				/>
				<Route
					element={<CampaignFormPage />}
					path={ROUTES.ADMINISTRATION.CAMPAIGNS_FORM}
				/>
				<Route
					element={<CampaignResultsPage />}
					path={ROUTES.ADMINISTRATION.CAMPAIGN_RESULTS}
				/>
				<Route
					element={<TypologyRisksPage />}
					path={ROUTES.ADMINISTRATION.TYPOLOGY_RISKS}
				/>
				<Route
					element={<ClassificationsPage />}
					path={ROUTES.ADMINISTRATION.CLASSIFICATIONS}
				/>
				<Route
					element={<SyncProtheusPage />}
					path={ROUTES.ADMINISTRATION.SYNC_PROTHEUS}
				/>
				<Route
					element={<CorrectInspectionPage />}
					path={ROUTES.ADMINISTRATION.FIX_INSPECTION}
				/>
				<Route element={<UsersPage />} path={ROUTES.ADMINISTRATION.USERS} />
				<Route
					element={<ContractsPage />}
					path={ROUTES.ADMINISTRATION.CONTRACTS}
				/>
				<Route
					element={<CustomersPage />}
					path={ROUTES.ADMINISTRATION.CUSTOMERS}
				/>
				<Route
					element={<OrgOverridesPage />}
					path={ROUTES.ADMINISTRATION.ORG_OVERRIDES}
				/>
				<Route
					element={<SpheraExportPage />}
					path={ROUTES.ADMINISTRATION.SPHERA_EXPORT}
				/>
				<Route
					element={<SpheraOptionsPage />}
					path={ROUTES.ADMINISTRATION.SPHERA_OPTIONS}
				/>
				<Route
					element={<CustomerClassificationsPage />}
					path={ROUTES.ADMINISTRATION.CUSTOMER_CLASSIFICATIONS}
				/>
				<Route
					element={<DDSMonthlyThemesPage />}
					path={ROUTES.ADMINISTRATION.DDS_MONTHLY_THEMES}
				/>
				<Route
					element={<CommitmentMatrixPage />}
					path={ROUTES.ADMINISTRATION.COMMITMENT_MATRIX}
				/>
				<Route element={<ScoringPage />} path={ROUTES.ADMINISTRATION.SCORING} />
				<Route
					element={<KpiMetricsPage />}
					path={ROUTES.ADMINISTRATION.KPI_METRICS}
				/>
				<Route
					element={<KpiMetricsPage />}
					path={ROUTES.ADMINISTRATION.KPI_METRICS_TAB}
				/>
			</Route>

			{/* ========== REDIRECT ========== */}
			<Route element={<Navigate replace to={ROUTES.PUBLIC.LOGIN} />} path="*" />
		</Routes>
	)
}
